import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";

const BTNS = [
  { img: "/btn_tk.png", to: "/login", testid: "welcome-tk-btn", alt: "Login TK Muslim Kids", w: "w-[70%]" },
  { img: "/btn_sd.png", to: "/sdqu-login", testid: "welcome-sd-btn", alt: "Login SD Muslim Kids", w: "w-[65%]" },
  { img: "/btn_info.png", to: "/informasi", testid: "welcome-info-btn", alt: "Informasi", w: "w-[55%]" },
];

export default function Welcome() {
  const navigate = useNavigate();
  const { user, ready } = useAuth();
  useEffect(() => { if (ready && user) navigate("/"); }, [ready, user, navigate]);

  return (
    <div className="min-h-screen flex justify-center bg-[#F9FBE7]">
      <div className="relative w-full md:max-w-md min-h-screen bg-center bg-cover bg-no-repeat"
        style={{ backgroundImage: "url('/landing_bg2.jpeg')" }} data-testid="welcome-screen">
        <div className="absolute top-[15%] left-0 right-0 flex flex-col items-center gap-2 px-8">
          {BTNS.map((b, i) => (
            <motion.img
              key={b.testid}
              src={b.img}
              alt={b.alt}
              data-testid={b.testid}
              onClick={() => navigate(b.to)}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, scale: [1, 1.05, 1], y: [0, -5, 0] }}
              whileTap={{ scale: 0.93 }}
              transition={{
                opacity: { duration: 0.4, delay: 0.15 + i * 0.12 },
                scale: { duration: 1.8, repeat: Infinity, ease: "easeInOut", delay: 0.5 + i * 0.35 },
                y: { duration: 1.8, repeat: Infinity, ease: "easeInOut", delay: 0.5 + i * 0.35 },
              }}
              className={`${b.w} cursor-pointer drop-shadow-lg`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
